import { createSlice } from '@reduxjs/toolkit';
import { Bulletin } from '@alucio/aws-beacon-amplify/src/models';
import { commonReducers, initialState } from './common';

const { reducers, extraReducers } = commonReducers<Bulletin>('bulletin');
const bulletinSlice = createSlice({
  name: 'bulletin',
  initialState: initialState<Bulletin>(),
  reducers,
  extraReducers,
});
export const bulletinActions = bulletinSlice.actions;
export default bulletinSlice;
